/**
 * The head families that carry a flame (DJ 2026-10-23), kept out of
 * GearSilhouettes, which sits at its file-size ceiling.
 *
 * - `candle`: a lit candle worn on the crown, baked into the ghost SVG
 *   (CandleHeadGear). A reusable template; no item wears it yet.
 *
 * A flame floating above the head is not a head family: it is the Flame slot
 * (lanternStyle.ts, drawn live by GhostLanternFx).
 */
import type { ItemEquipmentVisualDescriptor } from '../../../shared/equipmentVisuals';
import type { GearFitContext } from './GearGeometry';
import { CANDLE_DEFAULT_FLAME, renderCandleHead } from './CandleHeadGear';

type Renderer = (d: ItemEquipmentVisualDescriptor, context: GearFitContext) => string;

export function flameHeadFamilies(equipAttrs: (d: ItemEquipmentVisualDescriptor) => string): Record<'candle', Renderer> {
  return {
    candle: (d, context) => renderCandleHead(d.primaryColor, d.accentColor ?? CANDLE_DEFAULT_FLAME, d.variant, context, equipAttrs(d)),
  };
}
